import { SmartImage, type MediaRef } from '../../../components/media/SmartImage';

export function ArticleHeader({
  article,
}: {
  article: { title: string; excerpt: string | null; coverMedia: MediaRef };
}) {
  return (
    <div className="post-content">
      {/* Single <h1> per page: the article headline. */}
      <h1 className="title">{article.title}</h1>
      {article.excerpt && <p>{article.excerpt}</p>}
      <div className="thumb">
        {/* The cover is the article page's LCP element. */}
        <SmartImage
          media={article.coverMedia}
          alt={article.title}
          priority
          sizes="(max-width: 991px) 100vw, 66vw"
        />
      </div>
    </div>
  );
}
